import React, { useEffect, useState, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  ProgressBar,
} from "react-bootstrap";

import {
  FiUsers,
  FiBriefcase,
  FiCheckCircle,
  FiTrendingUp,
  FiCalendar,
  FiDollarSign,
  FiActivity,
  FiEye,
} from "react-icons/fi";

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  LineChart,
  Line,
} from "recharts";

import {
  getDashboardStats,
  getAdminProjects,
  getAdminRoles,
  getAdminAuditions
} from "../../services/adminApi";

import "./AdminDashboard.css";

const AdminDashboard = () => {
  const [stats, setStats] = useState({});

  const [monthlyData, setMonthlyData] = useState([]);
  const [
  roleCategoryData,
  setRoleCategoryData
] = useState([]);

  const [
  auditionData,
  setAuditionData
] = useState([]);

  const COLORS = [
  "#8B0000",
  "#A30000",
  "#C1121F",
  "#DC143C",
  "#F08080"
];

  useEffect(() => {
  loadDashboard();
}, []);

const loadDashboard = async () => {

  try {

    setLoading(true);

    // ===================================
    // ALL API CALLS
    // ===================================

    const [
      statsRes,
      projectsRes,
      rolesRes,
      auditionsRes
    ] = await Promise.all([

      getDashboardStats(),

      getAdminProjects(),

      getAdminRoles(),

      getAdminAuditions()
    ]);

    // ===================================
    // KPI
    // ===================================

    const statsData =
      statsRes?.data || {};

    setStats({

      candidates:
        statsData.candidates || 0,

      castingDirectors:
        statsData.castingDirectors || 0,

      projects:
        statsData.projects || 0,

      roles:
        rolesRes?.data?.length || 0,

      auditions:
        auditionsRes?.data?.total || 0,

      revenue: 0,

      activeUsers:
        statsData.candidates || 0,

      applications:
        auditionsRes?.data?.total || 0,
    });

    // ===================================
    // PROJECTS
    // ===================================

    // const projects =
    //   projectsRes?.data?.data || [];
 // ===================================
// PROJECTS
// ===================================

const projects =
  projectsRes?.data || [];

setRecentProjects(
  projects.slice(0, 5)
);

// ===================================
// PROJECT CATEGORY PIE CHART
// ===================================

const categoryMap = {};

projects.forEach((p) => {

  const type =
    p.project_type || "Other";

  categoryMap[type] =
    (categoryMap[type] || 0) + 1;
});

const formattedCategoryData =
  Object.keys(categoryMap).map(
    (key) => ({
      name: key,
      value: categoryMap[key],
    })
  );

setRoleCategoryData(
  formattedCategoryData
);

console.log(
  "PIE CHART DATA:",
  formattedCategoryData
);

    // ===================================
    // ROLES MONTHLY CHART
    // ===================================

    const roles =
      rolesRes?.data || [];

    const monthMap = {};

    roles.forEach((role) => {

      const month =
        new Date(
          role.created_at
        ).toLocaleString(
          "default",
          { month: "short" }
        );

      if (!monthMap[month]) {

        monthMap[month] = {
          month,
          revenue: 0,
          users: 0,
        };
      }

      monthMap[month].revenue +=
        Number(
          role.final_amount || 0
        );

      monthMap[month].users += 1;
    });

    setMonthlyData(
      Object.values(monthMap)
    );

    // ===================================
    // WEEKLY AUDITIONS
    // ===================================

    const auditionRows =
      auditionsRes?.data?.data || [];

    const weekMap = {};

    auditionRows.forEach((a) => {

      // const day =
      //   new Date(
      //     a.auditionDate
      //   ).toLocaleString(
      //     "default",
      //     { weekday: "short" }
      //   );
      const day =
  a.auditionMonth || "N/A";

      weekMap[day] =
        (weekMap[day] || 0) + 1;
    });

    setAuditionData(

      Object.keys(weekMap).map(
        (key) => ({
          name: key,
          auditions: weekMap[key],
        })
      )
    );

    // ===================================
    // RECENT AUDITIONS
    // ===================================

    setAuditions(
      auditionRows.slice(0, 5)
    );

  } catch (err) {

    console.log(
      "Dashboard Error:",
      err
    );

  } finally {

    setLoading(false);
  }
};

  // =========================================
  // KPI CARDS
  // =========================================

  const statCards = useMemo(
    () => [
      {
        title: "Candidates",
        value: stats.candidates || 0,
        icon: <FiUsers />,
        growth: "+12%",
      },

      {
        title: "Casting Directors",
        value: stats.castingDirectors || 0,
        icon: <FiUsers />,
        growth: "+5%",
      },

      {
        title: "Projects",
        value: stats.projects || 0,
        icon: <FiBriefcase />,
        growth: "+18%",
      },

      {
        title: "Roles",
        value: stats.roles ||0,
        icon: <FiCheckCircle />,
        growth: "+9%",
      },

      {
        title: "Auditions",
        value: stats.auditions ||0,
        icon: <FiCalendar />,
        growth: "+23%",
      },

      {
        title: "Revenue",
        value: `₹${Number(
  stats.revenue || 0
).toLocaleString()}`,
        icon: <FiDollarSign />,
        growth: "+31%",
      },

      {
        title: "Applications",
        value: stats.applications ||0,
        icon: <FiActivity />,
        growth: "+14%",
      },

      {
        title: "Active Users",
        value: stats.activeUsers ||0,
        icon: <FiEye />,
        growth: "+7%",
      },
    ],
    [stats]
  );

  // =========================================
  // RECENT PROJECTS
  // =========================================


  const [
  recentProjects,
  setRecentProjects
] = useState([]);

  // =========================================
  // RECENT AUDITIONS
  // =========================================


  const [
  auditions,
  setAuditions
] = useState([]);

const [loading, setLoading] =
useState(true);
  // =========================================
  // RENDER
  // =========================================

  return (
    <div className="admin-dashboard-page">
      {/* ========================================= */}
      {/* PAGE HEADER */}
      {/* ========================================= */}

      <div className="dashboard-header mb-4">
        <h2 className="dashboard-title">
          Dashboard Overview
        </h2>

        <p className="dashboard-subtitle">
          Welcome back Admin 👋
        </p>
      </div>

      {/* ========================================= */}
      {/* KPI CARDS */}
      {/* ========================================= */}

      <Row className="g-4 mb-4">
        {statCards.map((card, index) => (
          <Col
            xs={12}
            sm={6}
            lg={3}
            key={index}
          >
            <Card className="dashboard-stat-card h-100">
              <Card.Body className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="dashboard-icon">
                    {card.icon}
                  </div>

                  <div className="ms-3">
                    <p className="dashboard-card-title">
                      {card.title}
                    </p>

                    <h3 className="dashboard-card-value">
                      {card.value}
                    </h3>
                  </div>
                </div>

                <Badge bg="danger">
                  {card.growth}
                </Badge>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* ========================================= */}
      {/* CHART SECTION */}
      {/* ========================================= */}

      <Row className="g-4 mb-4">
        {/* AREA CHART */}
        <Col lg={8}>
          <Card className="dashboard-chart-card h-100">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="chart-title">
                  Monthly Platform Growth
                </h5>

                <Badge bg="danger">
                  2026
                </Badge>
              </div>

              <ResponsiveContainer
                width="100%"
                height={320}
              >
                <AreaChart data={monthlyData}>
                  <defs>
                    <linearGradient
                      id="colorRevenue"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="5%"
                        stopColor="#8B0000"
                        stopOpacity={0.8}
                      />

                      <stop
                        offset="95%"
                        stopColor="#8B0000"
                        stopOpacity={0}
                      />
                    </linearGradient>
                  </defs>

                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="#222"
                  />

                  <XAxis dataKey="month" />

                  <YAxis />

                  <Tooltip />

                  <Area
                    type="monotone"
                    dataKey="revenue"
                    stroke="#ff1744"
                    fillOpacity={1}
                    fill="url(#colorRevenue)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        {/* PIE CHART */}
        <Col lg={4}>
          <Card className="dashboard-chart-card h-100">
            <Card.Body>
              <h5 className="chart-title mb-4">
                Project Categories
              </h5>

              <ResponsiveContainer
                width="100%"
                height={320}
              >
                <PieChart>
                  <Pie
                    data={roleCategoryData}
                    cx="50%"
                    cy="50%"
                    outerRadius={110}
                    fill="#8884d8"
                    dataKey="value"
                    label
                  >
                    {roleCategoryData.map(
                      (entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={
                            COLORS[
                              index %
                                COLORS.length
                            ]
                          }
                        />
                      )
                    )}
                  </Pie>

                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* ========================================= */}
      {/* BAR + LINE CHART */}
      {/* ========================================= */}

      <Row className="g-4 mb-4">
        {/* BAR */}
        <Col lg={6}>
          <Card className="dashboard-chart-card h-100">
            <Card.Body>
              <h5 className="chart-title mb-4">
                Weekly Auditions
              </h5>

              <ResponsiveContainer
                width="100%"
                height={300}
                className="dashboard-chart-container"
              >
                <BarChart data={auditionData}>
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="#222"
                  />

                  <XAxis dataKey="name" />

                  <YAxis />

                  <Tooltip />

                  <Legend />

                  <Bar
                    dataKey="auditions"
                    fill="#8B0000"
                    radius={[8, 8, 0, 0]}
                     barSize={70}
                  />
                </BarChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        {/* LINE */}
        <Col lg={6}>
          <Card className="dashboard-chart-card h-100">
            <Card.Body>
              <h5 className="chart-title mb-4">
                User Activity
              </h5>

              <ResponsiveContainer
                width="100%"
                height={300}
              >
                {/* <LineChart data={monthlyData}> */}
                <AreaChart data={monthlyData}>
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="#222"
                  />

                  <XAxis dataKey="month" />

                  <YAxis />

                  <Tooltip />

                  <Legend />

                  {/* <Line
                    type="monotone"
                    dataKey="users"
                    // stroke="#c30000"
                    stroke="#DC143C"
                    strokeWidth={4}
                    dot={{
                      fill:"#fff",
                      stroke:"#DC143C",
                      strokeWidth:2,
                      r:5
                    }}
                    strokeWidth={3}
                  /> */}
                  <defs>
                    <linearGradient
                      id="userGradient"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="5%"
                        stopColor="#DC143C"
                        stopOpacity={0.8}
                      />
                      <stop
                        offset="95%"
                        stopColor="#DC143C"
                        stopOpacity={0}
                      />
                    </linearGradient>
                  </defs>

                  <Area
                    type="monotone"
                    dataKey="users"
                    stroke="#DC143C"
                    fill="url(#userGradient)"
                    strokeWidth={4}
                  />
                {/* </LineChart> */}
                </AreaChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* ========================================= */}
      {/* TABLES */}
      {/* ========================================= */}

      <Row className="g-4">
        {/* RECENT PROJECTS */}
        <Col lg={7}>
          <Card className="dashboard-table-card h-100">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="chart-title">
                  Recent Projects
                </h5>

                <Badge bg="danger">
                  Live
                </Badge>
              </div>

              {/* <div className="table-responsive"> */}
              <div className="table-responsive recent-projects-scroll">
                <Table
                  hover
                  borderless
                  className="dashboard-table align-middle"
                >
                  <thead>
                    <tr>
                      <th>Project</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Applications</th>
                    </tr>
                  </thead>

                  <tbody>
                    {recentProjects.map(
                      (project) => (
                        <tr key={project.id}>
                          <td>
                            {project.project_name}
                          </td>

                          <td>
                            {project.project_type}
                          </td>

                          <td>
                            <Badge
                              bg={
                                project.status ===
                                "Active"
                                  ? "success"
                                  : project.status ===
                                    "Casting"
                                  ? "warning"
                                  : "secondary"
                              }
                            >
                              {project.status}
                            </Badge>
                          </td>

                          <td>
                            {
                              project.applications
                            }
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* AUDITIONS */}
        <Col lg={5}>
          <Card className="dashboard-table-card h-100">
            <Card.Body>
              <h5 className="chart-title mb-4">
                Recent Auditions
              </h5>

 <div className="recent-auditions-scroll">
              {auditions.map(
                (item, index) => (
                  <div
                    key={index}
                    className="audition-item"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6>
                          {item.candidateName}
                        </h6>

                        {/* <p className="mb-1 text-muted auditions">
                          {item.roleName} •{" "}
                          {item.castingDirector}
                        </p> */}
                        <p className="audition-subtext">
                          {item.roleName} •{" "}
                          {item.castingDirector}
                        </p>
                      </div>

                      <Badge
                        bg={
                          item.status ===
                          "Selected"
                            ? "success"
                            : item.status ===
                              "Shortlisted"
                            ? "warning"
                            : item.status ===
                              "Rejected"
                            ? "danger"
                            : "secondary"
                        }
                      >
                        {item.status || "Pending"}
                      </Badge>
                    </div>

                    <ProgressBar
                      now={
                        item.status ===
                        "Selected"
                          ? 100
                          : item.status ===
                            "Shortlisted"
                          ? 70
                          : item.status ===
                            "Pending"
                          ? 40
                          : 20
                      }
                      variant="danger"
                      className="mt-2"
                    />
                  </div>
                )
              )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;